export const TOAST_AUTO_CLOSE_TIMEOUT = 5000;
export const TOAST_NOTIFICATIONS_LIMIT = 5;
